import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import type { TLngLat } from 'App/Map/types'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPointCategory } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const getFavoriteDepths = (): SharedTypes.TSoilSensorDepth[] => {
  const propertyId = selectedFieldAssetsStore.getState().property
  const properties = fieldAssetStore.getState().properties
  const soilPointCategory: TPointCategory = 'soilPoint'
  const soilStationLngLat: TLngLat | null = selectedFieldAssetsStore.getState()[soilPointCategory]

  let propertyPoints
  let soilStationFavoriteDepths: SharedTypes.TSoilSensorDepth[] = []

  if (propertyId && properties) {
    propertyPoints = properties[propertyId]?.points

    if (propertyPoints) {
      const soilStation = Object.values(propertyPoints).find((point) => {
        return point?.lngLat === soilStationLngLat
      })

      soilStationFavoriteDepths = soilStation?.configuration?.soilDefaultProbeDepths ?? []
    }
  }

  return soilStationFavoriteDepths
}
